<div class="menu-vertical" [ngClass]="{ visible }">
  <ng-content select="[menu-vertical-trigger]"></ng-content>
  <div class="menu-vertical-content">
    <ng-content></ng-content>
  </div>
</div>
